<template>
  <div class="hello">
  	<h1 v-text="$ml.get('hello.title')"/>
    <b-row class="mt-4">
      <b-col md="2"></b-col>
      <b-col md="8">
        <b-carousel
          id="carousel-1"
          :intervall="4000"
          controls
          indicators
          img-width="1024"
          img-height="440"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd">
          <b-carousel-slide img-src="static/img/provaslide3.png"></b-carousel-slide>
          <b-carousel-slide img-src="static/img/autostrada2.jpg">
            <p class="mt-4" v-html="$ml.get('hello.first_p')"></p>
          </b-carousel-slide>
        </b-carousel>
      </b-col>
      <b-col md="2"></b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="12">
        <p class="p-description" v-html="$ml.get('hello.description')"/>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      </b-col md="12">
        <features/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Features from '@/components/Features'
export default {
  data () {
    return {
      title: 'Tracking-Online®',
      slide: 0,
      sliding: true
    }
  },
  components: {Features},
  methods: {
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
.p-description {
  text-align: justify;
  padding: 0 2.2rem!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue